import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const ApplePayResultMob = () => {
  return <CommonResult />;
};

export default ApplePayResultMob;
